/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";

import disableApp from "../../assets/img/disableApp.png";
import AlertForm from "./alertForm";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import Loading from "../../components/Loading";
import { useTranslation } from "react-i18next";

const CustomSwitch = withStyles({
	switchBase: {
		color: "#326dff",
		"&$checked": { color: "#326dff" },
		"&$checked + $track": { backgroundColor: "#326dff" },
	},
	checked: {},
	track: {},
})(Switch);

const DisableApp = (props) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const shops = useSelector((state) => state.shops.shops);

	/* ================= STATE ================= */
	const [isOrderAvailable, setIsOrderAvailable] = useState(false);
	const [isDeliveryAvailable, setIsDeliveryAvailable] = useState(false);
	const [isPickupAvailable, setIsPickupAvailable] = useState(false);

	console.log(isOrderAvailable);

	/* ================= INIT ================= */
	useEffect(() => {
		if (!shops) return;

		const activeBrand =
			props.isNewAdmin &&
			shops
				.flatMap((shop) => shop.brands)
				.find((brand) => brand.id === props.keyShop && brand.isActive);

		const appSettings = props.isNewAdmin
			? activeBrand?.appSettings
			: shops[props.keyShop]?.appSettings;

		const checkoutScreen = props.isNewAdmin
			? activeBrand?.checkoutScreen
			: shops[props.keyShop]?.checkoutScreen;

		setIsOrderAvailable(!!appSettings?.isOrderAvailable);
		setIsDeliveryAvailable(!!checkoutScreen?.isDeliveryAvailable);
		setIsPickupAvailable(!!checkoutScreen?.isPickupAvailable);
	}, [shops, props.isNewAdmin, props.keyShop]);

	/* ================= HANDLERS ================= */
	const toggleApp = () => {
		props.updateStatusApp();
		setIsOrderAvailable((prev) => !prev);
	};

	const toggleCheckout = (type) => {
		const value =
			type === "delivery" ? !isDeliveryAvailable : !isPickupAvailable;

		props.updateStatusCheckout(value, type);

		if (type === "delivery") {
			setIsDeliveryAvailable(value);
		} else {
			setIsPickupAvailable(value);
		}
	};

	/* ================= RENDER ================= */
	return (
		<Grid container spacing={3}>
			<Grid item xs={12} md={7}>
				<Typography variant="h6" className={classes.title}>
					{t("disableApp.title")}
				</Typography>

				{shops ? (
					<FormGroup>
						<FormControlLabel
							control={
								<CustomSwitch checked={isOrderAvailable} onChange={toggleApp} />
							}
							label={t("disableApp.onApp")}
						/>
					</FormGroup>
				) : (
					<Loading size={22} color="#326dff" />
				)}

				<AlertForm alert={props.alert} onSubmit={props.updateAlert} />

				{props.pickupDeliveryControl && (
					<>
						{/* DELIVERY */}
						{shops ? (
							<FormGroup>
								<FormControlLabel
									control={
										<CustomSwitch
											checked={isDeliveryAvailable}
											onChange={() => toggleCheckout("delivery")}
										/>
									}
									label={t("disableApp.onDelivery")}
								/>
							</FormGroup>
						) : null}

						{/* PICKUP */}
						{shops ? (
							<FormGroup>
								<FormControlLabel
									control={
										<CustomSwitch
											checked={isPickupAvailable}
											onChange={() => toggleCheckout("pickup")}
										/>
									}
									label={t("disableApp.onPickup")}
								/>
							</FormGroup>
						) : null}
					</>
				)}
			</Grid>

			<Grid item xs={12} md={5}>
				<div className={classes.imgContainer}>
					<img className={classes.disableApp} src={disableApp} />
				</div>
			</Grid>
		</Grid>
	);
};

const useStyles = makeStyles(() => ({
	imgContainer: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
	},
	disableApp: {
		width: "100%",
		maxWidth: 300,
		height: "auto",
		margin: "auto",
		marginBottom: 10,
	},
	title: {
		marginBottom: 10,
		fontSize: 18,
	},
}));

export default DisableApp;
